import { useState, useMemo } from "react";
import {
  getConfiguredTimezone,
  setConfiguredTimezone,
  clearConfiguredTimezone,
  getBrowserTimezone,
  getAvailableTimezones,
} from "../../../utils/formatDate";

export interface TimezoneSetting {
  selected: string;
  search: string;
  browserTimezone: string;
  filtered: string[];
  setSearch: (search: string) => void;
  select: (timezone: string) => void;
  resetToBrowser: () => void;
}

/** The admin display timezone, persisted to localStorage only. */
export function useTimezoneSetting(): TimezoneSetting {
  const [selected, setSelected] = useState<string>(getConfiguredTimezone());
  const [search, setSearch] = useState("");
  const browserTimezone = getBrowserTimezone();
  const allTimezones = useMemo(() => getAvailableTimezones(), []);

  const filtered = useMemo(
    () =>
      search
        ? allTimezones.filter((tz) => tz.toLowerCase().includes(search.toLowerCase()))
        : allTimezones,
    [search, allTimezones]
  );

  const select = (timezone: string): void => {
    setSelected(timezone);
    setConfiguredTimezone(timezone);
    setSearch("");
  };

  const resetToBrowser = (): void => {
    clearConfiguredTimezone();
    setSelected(browserTimezone);
    setSearch("");
  };

  return { selected, search, browserTimezone, filtered, setSearch, select, resetToBrowser };
}
